import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Menu } from './menu';
import ActivityIndicator from './components/ActivityIndicator';
import { hideLoader } from './redux_files/actions/loaderActions';
import WhatsApp from './assets/whatsapp.png';
import Phone from './assets/phone.png';
import { getWhatsAppLink, PHONE_NUMBER_WITH_PREFIX } from './utils/constants';


function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Hide loader on app reload/mount
    dispatch(hideLoader());
  }, [dispatch]);

  return (
    <div className='App '>
      {/* Global Activity Indicator - Controlled from Redux */}
      <ActivityIndicator />
      
      <Menu />
      <a href={getWhatsAppLink()} target='_blank' rel="noreferrer" className='whatsApp'>
        <img src={WhatsApp} alt='Shivay Durga' width={36} height={36} />
      </a>
      <a href={`tel:${PHONE_NUMBER_WITH_PREFIX}`}>
        <img src={Phone} alt='Contact Us' width={36} height={36} className='callToAction' />
      </a>
    </div>
  );
}

export default App;
